
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","data-name":"Layer 1","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 24H6a5.006 5.006 0 01-5-5V5a5.006 5.006 0 015-5h12a5.006 5.006 0 015 5v14a5.006 5.006 0 01-5 5zM6 2a3 3 0 00-3 3v14a3 3 0 003 3h12a3 3 0 003-3V5a3 3 0 00-3-3zm10 8H8a3 3 0 010-6h8a3 3 0 010 6zM8 6a1 1 0 000 2h8a1 1 0 000-2zm-2 7a1 1 0 101 1 1 1 0 00-1-1zm4 0a1 1 0 101 1 1 1 0 00-1-1zm4 0a1 1 0 101 1 1 1 0 00-1-1zm-8 4a1 1 0 101 1 1 1 0 00-1-1zm4 0a1 1 0 101 1 1 1 0 00-1-1zm8-4a1 1 0 101 1 1 1 0 00-1-1zm1 5a1 1 0 00-1-1h-4a1 1 0 000 2h4a1 1 0 001-1z"}})])
          )
        }
      }
    